$(->
  window.cp_init_autocomplete = (item, opts)->
    if opts?
      s2_opts = opts
    else
      s2_opts = {}
    unless item.data('showall')?
      s2_opts.minimumInputLength = 2

    if $(item).attr('multiple') == 'multiple'
      s2_opts.multiple = true

    remote = $(item).data('remote')
    if item.data('remote')?
      param = $(item).data('param')
      s2_opts.ajax =
        url: remote
        dataType: 'json'
        data: (params)->
          result = {}
          result[param] = params.term
          result
        processResults: (data, params)->
          result = []
          for row in data
            result.push({ id: row.id, text: row[param] })
          {
            results: result
            pagination:
              more: false
          }
        cache: true
    else
      if $(item).data('tags') == 1
        s2_opts.tags = true

      false

    item.select2 s2_opts

  $('.autocomplete').each ->
    window.cp_init_autocomplete($(this))

  $(document).on 'show.bs.modal', '.modal', ->
    the_modal = $(this)
    the_modal.find('.autocomplete').each ->
      unless $(this).hasClass('select2-container')
        window.cp_init_autocomplete($(this), { dropdownParent: the_modal.find('.modal-body') })
)
